import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import "../css/Login.css";
import "../css/ForgotPassword.css";
import viewIcon from "../assets/icons/view.png";
import hideIcon from "../assets/icons/hide.png";

export default function ResetPassword() {
  const { resetPassword, loading, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const { user_id, email } = location.state || {};

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");
  const [success, setSuccess] = useState(false);

  if (!user_id) {
    return (
      <div className="login-wrapper">
        <div className="login-main">
          <div className="login-card" style={{ margin: "auto" }}>
            <p className="login-error">Invalid reset session. Please start again.</p>
            <button className="login-button" onClick={() => navigate("/forgot-password")}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError("");

    if (otp.length < 4) return setLocalError("Please enter a valid OTP");
    if (newPassword.length < 8) return setLocalError("Password must be at least 8 characters");
    if (newPassword !== confirmPassword) return setLocalError("Passwords do not match");

    const ok = await resetPassword({ user_id, otp, new_password: newPassword });
    if (ok) setSuccess(true);
  };

  if (success) {
    return (
      <div className="login-wrapper">
        <div className="login-main">
          <motion.div
            className="login-right"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            style={{ margin: "auto" }}
          >
            <div className="login-card">
              <div className="fp-success">
                <div className="fp-success-icon">✓</div>
                <h2>Password Reset!</h2>
                <p>Your password has been updated successfully.</p>
                <button className="login-button" onClick={() => navigate("/")}>
                  Login Now
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-main">
        <div className="login-left">
          <h2>New Password</h2>
          <p className="login-aidora-text">
            Enter the OTP sent to <strong>{email}</strong> and choose a new password.
          </p>
        </div>

        <motion.div
          className="login-right"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div className="login-card">
            <h2>Reset Password</h2>

            <form onSubmit={handleSubmit}>
              {(error || localError) && (
                <div className="login-error">{error || localError}</div>
              )}

              {/* OTP */}
              <div className="login-floating-field">
                <input
                  type="text"
                  placeholder=" "
                  maxLength={6}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
                <label>OTP</label>
              </div>

              {/* New Password */}
              <div className="login-floating-field">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <label>New Password</label>
                <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
                  <img src={showPassword ? viewIcon : hideIcon} alt="toggle" />
                </span>
              </div>

              {/* Confirm Password */}
              <div className="login-floating-field">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <label>Confirm Password</label>
              </div>

              <button className="login-button" disabled={loading}>
                {loading ? "Resetting..." : "Reset Password"}
              </button>

              <button
                type="button"
                className="login-signup-button"
                onClick={() => navigate("/forgot-password")}
              >
                Back
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
